module.exports = __webpack_public_path__ + "static/media/ehealthpro_faq-banner-graphic.ac77a0d6.png";